import * as React from 'react';
import Skills from "@components/Skills";
import { Helmet } from "react-helmet";
import { withRouter, RouteComponentProps } from 'react-router-dom';

export interface Props extends RouteComponentProps { }

const SkillsContainer: React.SFC<Props> = (props: Props) => {
    const title = 'Skills Map - Nick Avasiloi | Full Stack Web Developer, Artificial Intelligence Specialist';
    const description = 'Interactive representation of the gained competencies and skills derived from past jobs';
    const url = process.env.REACT_APP_URL + props.location.pathname;

    return (
        <>
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={description} />
                
                <meta name="og:title" content={title} />
                <meta name="og:description" content={description} />
                <meta name="og:url" content={url} />
                <meta name="og:image" content={`${process.env.REACT_APP_URL}/images/skills.gif`} />
            </Helmet>
            <Skills />
        </>
    );
}

const SkillsContainerRouted = withRouter(SkillsContainer);
export default SkillsContainerRouted;


// WEBPACK FOOTER //
// ./src/containers/Skills/index.tsx